const lineCurveScale = 0.75;
const node_width = 100;
const node_height = 30;

export function generateLinkPath(origX,origY, destX, destY, sc, hasStatus = false) {
    var dy = destY-origY;
    var dx = destX-origX;
    var delta = Math.sqrt(dy*dy+dx*dx);
    var scale = lineCurveScale;
    var scaleY = 0;
    if (dx*sc > 0) {
        if (delta < node_width) {
            scale = 0.75-0.75*((node_width-delta)/node_width);
            // scale += 2*(Math.min(5*node_width,Math.abs(dx))/(5*node_width));
            // if (Math.abs(dy) < 3*node_height) {
            //     scaleY = ((dy>0)?0.5:-0.5)*(((3*node_height)-Math.abs(dy))/(3*node_height))*(Math.min(node_width,Math.abs(dx))/(node_width)) ;
            // }
        }
    } else {
        scale = 0.4-0.2*(Math.max(0,(node_width-Math.min(Math.abs(dx),Math.abs(dy)))/node_width));
    }
    function genCP(cp) {
        return ` M ${cp[0]-5} ${cp[1]} h 10 M ${cp[0]} ${cp[1]-5} v 10 `
    }
    if (dx*sc > 0) {
        let cp = [
            [(origX+sc*(node_width*scale)), (origY+scaleY*node_height)],
            [(destX-sc*(scale)*node_width), (destY-scaleY*node_height)]
        ]
        return `M ${origX} ${origY} C ${cp[0][0]} ${cp[0][1]} ${cp[1][0]} ${cp[1][1]} ${destX} ${destY}`
            //    + ` ${genCP(cp[0])} ${genCP(cp[1])}`
    } else {
        let topX, topY, bottomX, bottomY
        let cp
        let midX = Math.floor(destX-dx/2);
        let midY = Math.floor(destY-dy/2);          
        if (Math.abs(dy) < 10) {
            bottomY = Math.max(origY, destY) + (hasStatus?35:25)
            let startCurveHeight = bottomY - origY
            let endCurveHeight = bottomY - destY
            cp = [
                [ origX + sc*15 , origY ],
                [ origX + sc*25 , origY + 5 ],
                [ origX + sc*25 , origY + startCurveHeight/2 ],

                [ origX + sc*25 , origY + startCurveHeight - 5 ],
                [ origX + sc*15 , origY + startCurveHeight ],
                [ origX , origY + startCurveHeight ],

                [ destX - sc*15, origY + startCurveHeight ],
                [ destX - sc*25, origY + startCurveHeight - 5 ],
                [ destX - sc*25, destY + endCurveHeight/2 ],

                [ destX - sc*25, destY + 5 ],
                [ destX - sc*15, destY ],
                [ destX, destY ],
            ]

            return "M "+origX+" "+origY+
                " C "+
                cp[0][0]+" "+cp[0][1]+" "+
                cp[1][0]+" "+cp[1][1]+" "+
                cp[2][0]+" "+cp[2][1]+" "+
                " C " +
                cp[3][0]+" "+cp[3][1]+" "+
                cp[4][0]+" "+cp[4][1]+" "+
                cp[5][0]+" "+cp[5][1]+" "+
                " h "+dx+
                " C "+
                cp[6][0]+" "+cp[6][1]+" "+
                cp[7][0]+" "+cp[7][1]+" "+
                cp[8][0]+" "+cp[8][1]+" "+
                " C " +
                cp[9][0]+" "+cp[9][1]+" "+
                cp[10][0]+" "+cp[10][1]+" "+
                cp[11][0]+" "+cp[11][1]+" "
                // +genCP(cp[0])+genCP(cp[1])+genCP(cp[2])+genCP(cp[3])+genCP(cp[4])
                // +genCP(cp[5])+genCP(cp[6])+genCP(cp[7])+genCP(cp[8])+genCP(cp[9])+genCP(cp[10])
        } else {
            var cp_height = node_height/2;
            var y1 = (destY + midY)/2
            topX = origX + sc*node_width*scale;
            topY = dy>0?Math.min(y1 - dy/2 , origY+cp_height):Math.max(y1 - dy/2 , origY-cp_height);
            bottomX = destX - sc*node_width*scale;
            bottomY = dy>0?Math.max(y1, destY-cp_height):Math.min(y1, destY+cp_height);
            var x1 = (origX+topX)/2;
            var scy = dy>0?1:-1;
            cp = [
                // Orig -> Top
                [x1,origY],
                [topX,dy>0?Math.max(origY, topY-cp_height):Math.min(origY, topY+cp_height)],
                // Top -> Mid
                // [Mirror previous cp]
                [x1,dy>0?Math.min(midY, topY+cp_height):Math.max(midY, topY-cp_height)],
                // Mid -> Bottom
                // [Mirror previous cp]
                [bottomX,dy>0?Math.max(midY, bottomY-cp_height):Math.min(midY, bottomY+cp_height)],
                // Bottom -> Dest
                // [Mirror previous cp]
                [(destX+bottomX)/2,destY]
            ];
            if (cp[2][1] === topY+scy*cp_height) {
                if (Math.abs(dy) < cp_height*10) {
                    cp[1][1] = topY-scy*cp_height/2;
                    cp[3][1] = bottomY-scy*cp_height/2;
                }
                cp[2][0] = topX;
            }
            return "M "+origX+" "+origY+
                " C "+
                cp[0][0]+" "+cp[0][1]+" "+
                cp[1][0]+" "+cp[1][1]+" "+
                topX+" "+topY+
                " S "+
                cp[2][0]+" "+cp[2][1]+" "+
                midX+" "+midY+
            " S "+
                cp[3][0]+" "+cp[3][1]+" "+
                bottomX+" "+bottomY+
                " S "+
                    cp[4][0]+" "+cp[4][1]+" "+
                    destX+" "+destY

            // +genCP(cp[0])+genCP(cp[1])+genCP(cp[2])+genCP(cp[3])+genCP(cp[4])
        }
    }
}

export function calculateTextWidth(str, className) {
    var result = convertLineBreakCharacter(str);
    var width = 0;
    for (var i=0;i<result.length;i++) {
        var calculateTextW=calculateTextDimensions(result[i],className)[0];
        if (width<calculateTextW) {
            width=calculateTextW;
        }
    }
    return width;
}
export function getLabelParts(str, className) {
    var lines = convertLineBreakCharacter(str);
    var width = 0;
    for (var i=0;i<lines.length;i++) {
        var calculateTextW = calculateTextDimensions(lines[i],className)[0];
        if (width<calculateTextW) {
            width=calculateTextW;
        }
    }
    return {
        lines:lines,
        width: width
    }
}

var textDimensionPlaceholder = {};
var textDimensionCache = {};
export function calculateTextDimensions(str,className) {
    var cacheKey = "!"+str;
    if (!textDimensionPlaceholder[className]) {
        textDimensionPlaceholder[className] = document.createElement("span");
        textDimensionPlaceholder[className].className = className;
        textDimensionPlaceholder[className].style.position = "absolute";
        textDimensionPlaceholder[className].style.top = "-1000px";
        document.getElementById("red-ui-editor").appendChild(textDimensionPlaceholder[className]);
        textDimensionCache[className] = {};
    } else {
        if (textDimensionCache[className][cacheKey]) {
            return textDimensionCache[className][cacheKey]
        }
    }
    textDimensionPlaceholder[className].textContent = (str||"");
    var w = textDimensionPlaceholder[className].offsetWidth;
    var h = textDimensionPlaceholder[className].offsetHeight;
    textDimensionCache[className][cacheKey] = [w,h];
    return textDimensionCache[className][cacheKey];
}

export function convertLineBreakCharacter(str) {
    var result = [];
    var lines = str.split(/\\n /);
    if (lines.length > 1) {
        var i=0;
        for (i=0;i<lines.length - 1;i++) {
            if (/\\$/.test(lines[i])) {
                result.push(lines[i]+"\\n "+lines[i+1])
                i++;
            } else {
                result.push(lines[i])
            }
        }
        if ( i === lines.length - 1) {
            result.push(lines[lines.length-1]);
        }
    } else {
        result = lines;
    }
    result = result.map(function(l) { return l.replace(/\\\\n /g,"\\n ").trim() })
    return result;
}
